import React, { useState, useTransition, useEffect } from "react";
import { TabButtonFlatButton } from "../../../common-components";
import { colors } from "../../../../themes/Colors";
import {
  ActionBar,
  UserListItem,
  UserHeader,
  UserPopUpDisplay,
} from "./components";

const UserDisplay = ({
  companyInformation,
  setLoading,
  setPopUpTitle,
  setToastPop,
  setMessage,
}) => {
  const [tableDisplay, setTableDisplay] = useState("registered");
  const [userPopUp, setUserPopUp] = useState(false);
  const [agencyCustomersArray, setAgencyCustomerArray] = useState(null);

  // get all customers linked to agency
  const getAgencyCustomers = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        "https://driverfrienddatabase-h2aa.onrender.com" +
          "/agency/getAgencyCustomers",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            agencyId: companyInformation._id,
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.success) {
        setAgencyCustomerArray(respnseData.customers);

        // setToastPop(true);
        // setPopUpTitle("SUCCESS");
        // setMessage("Log-in successful");
        setLoading(false);

        // setToastPop(true);
      } else {
        setLoading(false);
        setPopUpTitle("FAILED");
        setMessage("Unable to find customers, " + " " + respnseData.message);
        setToastPop(true);
      }
    } catch (err) {
      console.log("error", err);
      setLoading(false);
      setMessage(
        "Unable to login into account, please wait 5 mins then try again or contact support" +
          " " +
          err
      );
      setToastPop(true);
      console.log("error", err);
    }
  };
  // console.log("agencyCustomersArray", agencyCustomersArray);

  useEffect(() => {
    getAgencyCustomers();
  }, [companyInformation]);
  return (
    <div
      style={{
        flex: 1,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        position: "relative",
      }}
    >
      {/* //tab buttons for screen display */}
      {userPopUp ? null : (
        <div style={{ position: "fixed", top: 30, display: "flex" }}>
          <div style={{ marginLeft: 10 }}>
            <TabButtonFlatButton
              title={"REGISTERED USERS"}
              backgroundColor={
                tableDisplay === "registered"
                  ? colors.secondaryGrey
                  : colors.secondaryDarkBlue
              }
              textColor={
                tableDisplay === "registered"
                  ? colors.secondaryDarkBlue
                  : colors.white
              }
              onClick={() => setTableDisplay("registered")}
            />
          </div>
          {/* <div style={{ marginLeft: 5 }}>
            <TabButtonFlatButton
              title={"LEADS"}
              backgroundColor={
                tableDisplay === "leads"
                  ? colors.secondaryGrey
                  : colors.secondaryDarkBlue
              }
              textColor={
                tableDisplay === "leads"
                  ? colors.secondaryDarkBlue
                  : colors.white
              }
              onClick={() => setTableDisplay("leads")}
            />
          </div> */}

          {/* <div style={{ marginLeft: 5 }}>
            <TabButtonFlatButton
              title={"REQUESTS"}
              backgroundColor={
                tableDisplay === "requests"
                  ? colors.secondaryGrey
                  : colors.secondaryDarkBlue
              }
              textColor={
                tableDisplay === "requests"
                  ? colors.secondaryDarkBlue
                  : colors.white
              }
              onClick={() => setTableDisplay("requests")}
            />
          </div> */}
        </div>
      )}
      <ActionBar title={"USERS / CUSTOMERS"} />
      <UserHeader />
      <div
        style={{
          flex: 1,
          // borderStyle: "solid",
          display: "flex",
          flexDirection: "column",
          overflowY: "scroll",
          overflowX: "hidden",
          justifyContent: "flex-start",
          alignItems: "center ",
          maxHeight: 750,
        }}
      >
        <div style={{ minHeight: 5 }} />
        {agencyCustomersArray
          ? agencyCustomersArray.map((item, index) => {
              return (
                <div key={index} style={{ width: "100%" }}>
                  <UserListItem
                    userName={item.firstName + " " + item.lastName}
                    email={item.email}
                    cellNumber={item.cellNumber}
                    onClick={() => setUserPopUp(item)}
                  />
                </div>
              );
            })
          : null}
      </div>
      <UserPopUpDisplay
        display={userPopUp}
        setUserPopUp={setUserPopUp}
        setLoading={setLoading}
        setMessage={setMessage}
        setPopUpTitle={setPopUpTitle}
        setToastPop={setToastPop}
        companyInformation={companyInformation}
      />
    </div>
  );
};
export default UserDisplay;
